import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import Header from "../components/Header.js";

const Home = ({ setIsAuthenticated }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  console.log("Contenu de setIsAuthenticated:", setIsAuthenticated);

  return (
    <div className="overflow-hidden">
      <Header setIsAuthenticated={setIsAuthenticated} />

      {/* Hero Section */}
      <section
        className="hero text-white text-center d-flex align-items-center"
        style={{
          minHeight: "90vh",
          backgroundImage:
            "linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url('/images/spaghetti.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed", // Effet parallaxe léger
        }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col ol lg={9} xl={8}>
              <h1 className="display-3 fw-bold mb-3 animate__animated animate__fadeInDown">
                Simplifiez vos repas à l'école ! 🍽️
              </h1>
              <p className="fs-4 mb-5 opacity-90 fw-light">
                Commandez en ligne et recevez votre repas directement en salle
                ou au 6e étage sans effort.
              </p>

              <div className="row justify-content-center">
                {user ? (
                  <div className="col">
                  <Button
                    as={Link}
                    to="/dashboard"
                    className="px-5 py-3 rounded-pill shadow-lg border-0 fw-bold transition-all"
                    style={{ backgroundColor: "#f5721e", fontSize: "1.1rem" }}
                  >
                    Accéder au Dashboard
                  </Button>
                  </div>
                ) : (
                  <>
                    <div className="col-12 col-md-6 mb-3 mb-md-0">
                      <Button
                        as={Link}
                        to="/connexion"
                        className="px-5 py-3 rounded-pill shadow-lg border-0 fw-bold text-white transition-all"
                        style={{
                          backgroundColor: "#f5721e",
                          
                        }}
                      >
                        Se connecter
                      </Button>
                    </div>
                    <div className="col-12 col-md-6">
                      <Button
                        as={Link}
                        to="/inscription"
                        variant="outline-light"
                        className="px-5 py-3 rounded-pill fw-bold"
                        style={{  }}
                      >
                        Créer un compte
                      </Button>
                    </div>
                  </>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Features Section */}
      <section className="py-5 bg-white">
        <Container className="py-5">
          <Row className="text-center mb-5">
            <Col>
              <h2
                className="display-5 fw-bold mb-3"
                style={{ color: "#2d3436" }}
              >
                Pourquoi choisir{" "}
                <span style={{ color: "#f5721e" }}>Commando</span> ?
              </h2>
              <div
                className="mx-auto bg-warning mb-4"
                style={{ height: "4px", width: "60px", borderRadius: "2px" }}
              ></div>
              <p className="text-muted fs-5">
                Un service conçu par des étudiants, pour des étudiants.
              </p>
            </Col>
          </Row>

          <Row
            className="g-4  p-4 rounded shadow-sm"
            style={{ backgroundColor: "#f5721e" }}
          >
            {[
              {
                icon: "📅",
                title: "Commande en ligne",
                text: "Parcourez le menu du jour et réservez votre plat en 30 secondes.",
              },
              {
                icon: "🚀",
                title: "Livraison Express",
                text: "On vous livre directement à votre place. Ne manquez plus une minute de cours.",
              },
              {
                icon: "🛎️",
                title: "Zéro Attente",
                text: "Fini les files d'attente interminables à la cafétéria ou au restaurant.",
              },
            ].map((feature, idx) => (
              <Col md={4} key={idx}>
                <Card className="h-100 border-0 shadow-sm text-center p-4 card-hover">
                  <Card.Body>
                    <div className="display-4 mb-3">{feature.icon}</div>
                    <h4 className="fw-bold mb-3">{feature.title}</h4>
                    <p className="text-muted mb-0">{feature.text}</p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* New: How It Works Section */}
      <section className="py-5" style={{ backgroundColor: "#f8f9fa" }}>
        <Container className="py-5">
          <Row className="text-center mb-5">
            <Col>
              <h2 className="fw-bold">Comment ça marche ?</h2>
              <p className="text-muted">Votre repas en 4 étapes simples</p>
            </Col>
          </Row>
          <Row className="position-relative">
            {/* Ligne décorative (Desktop uniquement) */}
            <div
              className="position-absolute d-none d-lg-block"
              style={{
                top: "25%",
                left: "10%",
                right: "10%",
                borderTop: "2px dashed #f5721e",
                zIndex: 0,
              }}
            ></div>

            {[
              {
                step: "1",
                title: "Compte",
                desc: "Inscrivez-vous avec vos infos.",
              },
              {
                step: "2",
                title: "Choix",
                desc: "Sélectionnez le menu du jour.",
              },
              {
                step: "3",
                title: "Paiement",
                desc: "Payez à la livraison.",
              },
              {
                step: "4",
                title: "Dégustez",
                desc: "Recevez votre plat chaud !",
              },
            ].map((item, idx) => (
              <Col
                md={6}
                lg={3}
                key={idx}
                className="text-center mb-4 mb-lg-0"
                style={{ zIndex: 1 }}
              >
                <div
                  className="rounded-circle bg-white shadow-sm d-flex align-items-center justify-content-center mx-auto mb-3"
                  style={{
                    width: "80px",
                    height: "80px",
                    border: "3px solid #f5721e",
                  }}
                >
                  <span
                    className="h3 mb-0 fw-bold"
                    style={{ color: "#f5721e" }}
                  >
                    {item.step}
                  </span>
                </div>
                <h5 className="fw-bold">{item.title}</h5>
                <p className="text-muted small px-3">{item.desc}</p>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* New: Stats / Trust Section */}
      <section
        className="py-5 text-white"
        style={{ background: "linear-gradient(45deg, #2d3436, #000)" }}
      >
        <Container>
          <Row className="text-center g-4">
            <Col md={4}>
              <div className="p-3">
                <h2 className="display-4 fw-black text-warning">500+</h2>
                <p className="text-uppercase mb-0 opacity-75">Repas Servis</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="p-3">
                <h2 className="display-4 fw-black text-warning">6e Étage</h2>
                <p className="text-uppercase mb-0 opacity-75">Point de RDV</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="p-3">
                <h2 className="display-4 fw-black text-warning">100%</h2>
                <p className="text-uppercase mb-0 opacity-75">Étudiant-Made</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Testimonials Section */}
      <section className="py-5 bg-white">
        <Container className="py-5">
          <Row className="text-center mb-5">
            <Col>
              <h2 className="fw-bold">Ce que disent les étudiants 💬</h2>
              <p className="text-muted">Ils ont testé et ils adorent !</p>
            </Col>
          </Row>
          <Row>
            {[
              {
                name: "Marc K.",
                role: "Étudiant en SIL",
                text: "Le gain de temps est incroyable. Je commande à la pause et mon plat m'attend devant la salle.",
              },
              {
                name: "Awa D.",
                role: "Étudiante en HTR",
                text: "Une super plateforme qui met en valeur notre travail en cuisine. Très simple à utiliser.",
              },
              {
                name: "Jean P.",
                role: "Étudiant en Management",
                text: "Fini la queue de 20 minutes. Commando a vraiment changé mes pauses déjeuner !",
              },
            ].map((testimonial, idx) => (
              <Col md={4} key={idx} className="mb-4">
                <Card
                  className="h-100 bg-light p-3 shadow-lg italic"
                  style={{
                    backgroundColor: "#f5721e",
                    border: "1px solid red",
                  }}
                >
                  <Card.Body>
                    <p className="mb-3">"{testimonial.text}"</p>
                    <footer className="blockquote-footer mt-2 text-primary fw-bold">
                      {testimonial.name}{" "}
                      <cite
                        title="Source Title"
                        className="text-muted fw-normal"
                      >
                        ({testimonial.role})
                      </cite>
                    </footer>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
      {/* Section FAQ & CTA */}
      <section className="mb-2">
        {/* FAQ Section */}
        <div className="col-12">
          <div className="py-5" style={{ backgroundColor: "#f8f9fa" }}>
            <Container>
              <Row className="justify-content-center">
                <Col lg={8}>
                  <h2 className="fw-bold text-center mb-5">
                    Questions fréquentes
                  </h2>
                  <div
                    className="accordion shadow-sm rounded overflow-hidden"
                    id="faqCommando"
                  >
                    <div className="accordion-item border-0 mb-2">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button fw-bold text-white"
                          style={{ backgroundColor: "#f5721e" }}
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#faq1"
                        >
                          Où puis-je me faire livrer ?
                        </button>
                      </h2>
                      <div
                        id="faq1"
                        className="accordion-collapse collapse show"
                        data-bs-parent="#faqCommando"
                      >
                        <div className="accordion-body text-muted">
                          Nous livrons principalement dans toutes les salles de
                          classe et au point de retrait dédié au 6e étage.
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item border-0">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button collapsed fw-bold text-white"
                          style={{ backgroundColor: "#f5721e" }}
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#faq2"
                        >
                          Quels sont les moyens de paiement ?
                        </button>
                      </h2>
                      <div
                        id="faq2"
                        className="accordion-collapse collapse"
                        data-bs-parent="#faqCommando"
                      >
                        <div className="accordion-body text-muted">
                          Pour le moment, nous acceptons le paiement à la
                          livraison (Cash ou Mobile Money selon le livreur).
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </section>

      {/* CTA Section (Avant le footer) */}
      <section className="col-12">
        <div className="py-5 text-center">
          <Container className="">
            <h2 className="fw-bold mb-4">
              Prêt à passer votre première commande ?
            </h2>
            <Button
              as={Link}
              to={user ? "/new_order" : "/inscription"}
              className="btn-md py-2 rounded-pill border-0 shadow transition-all"
              style={{ backgroundColor: "#f5721e", color: "white", height: "50px", width: "250px", fontSize: "1.1rem" }}
            >
              {user ? "Aller au menu" : "Démarrer l'aventure"}
            </Button>
          </Container>
        </div>
      </section>

      {/* Footer */}
      <footer
        className="py-5 text-white"
        style={{ backgroundColor: "#1a1a1a", borderTop: "5px solid #f5721e" }}
      >
        <Container>
          <Row className="align-items-center">
            <Col md={6} className="text-center text-md-start mb-3 mb-md-0">
              <h4 className="fw-bold mb-0">COMMANDO</h4>
              <small className="opacity-50">
                La solution repas de votre campus.
              </small>
            </Col>
            <Col md={6} className="text-center text-md-end">
              <p className="mb-0 text-white small">
                © {new Date().getFullYear()}{" "}
                <span className="text-white small">
                  Commando. Développé avec ❤️ pour les étudiants.
                </span>
              </p>
            </Col>
          </Row>
        </Container>
      </footer>

      {/* CSS pour les effets de survol - À mettre dans votre fichier CSS principal */}
      <style>{`
                .card-hover {
                    transition: transform 0.3s ease, shadow 0.3s ease;
                }
                .card-hover:hover {
                    transform: translateY(-10px);
                    box-shadow: 0 1rem 3rem rgba(0,0,0,0.1) !important;
                }
                .transition-all {
                    transition: all 0.3s ease;
                }
                .transition-all:hover {
                    transform: scale(1.05);
                    filter: brightness(1.1);
                }
            `}</style>
    </div>
  );
};

export default Home;
